/*
 * Copyright © 2017-2026 Knowledge for Decisions (K4D). All rights reserved.
 *
 * This code and associated materials are protected by copyright laws and international
 * treaties. Unauthorized use, reproduction, distribution, or modification of any content
 * from Knowledge for Decisions (K4D) is strictly prohibited. For inquiries regarding
 * the use or licensing of K4D's opyrighted materials, please contact us at
 * contact@k4d.com.br. "Knowledge for Decisions (K4D)" and the slogan "Using data to make
 * precise decisions" are registered trademarks of Knowledge for Decisions (K4D).
 */

export type CepData = {
  cep: string;
  logradouro: string;
  complemento: string;
  bairro: string;
  localidade: string;
  uf: string;
  ibge: string;
  gia: string;
  ddd: string;
  siafi: string;
};

export type CepReturn = {
  data?: CepData;
  error?: string;
};

export type GetCepData = (cep: string) => Promise<CepReturn>;

// Helper function to validate CEP format
/**
 * isValidCepFormat function.
 *
 * @param {*} cep - Parameter description
 *
 * @returns {*} Return value description
 */
function isValidCepFormat(cep: string): boolean {
  return /^[0-9]+$/.test(cep) && cep.length === 8;
}

// Helper function to handle invalid CEP
/**
 * handleInvalidCep function.
 *
 * @returns {*} Return value description
 */
function handleInvalidCep(): { error: string } {
  const errorMessage = "The Zip code is invalid";
  console.error(errorMessage);
  return { error: errorMessage };
}

// Helper function to check if CEP data has error
/**
 * hasCepError function.
 *
 * @param {*} cepData - Parameter description
 *
 * @returns {*} Return value description
 */
function hasCepError(cepData: any): boolean {
  return !!cepData?.erro;
}

export const getCepData: GetCepData = async (cep) => {
  await new Promise((resolve) => {
    setTimeout(resolve, 1000);
  });
  
  if (!isValidCepFormat(cep)) {
    return handleInvalidCep();
  }

  const URL = `https://viacep.com.br/ws/${cep}/json/`;
  try {
    const response = await fetch(URL);
    const cepData = await response.json();

    if (hasCepError(cepData)) {
      return handleInvalidCep();
    }

    return { data: cepData };
  } catch (error) {
    throw new Error("Could not retrieve CEP data from API\n" + error);
  }
};